import React from 'react';
import { IconProps } from '.';
import { circleColor, strokeColor } from './icons.utils';

export const UsersIcon: React.FC<IconProps> = ({
  active,
  className = '',
}: IconProps): JSX.Element => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12.0001" cy="12.4736" r="12" fill={circleColor(active)} />
      <rect
        x="5.5"
        y="4.97363"
        width="13"
        height="15"
        rx="1"
        stroke={strokeColor(active)}
        strokeWidth="2"
      />
      <rect
        x="8.5"
        y="8.47363"
        width="7"
        height="2"
        rx="1"
        fill={strokeColor(active)}
      />
      <rect
        x="8.5"
        y="11.4736"
        width="7"
        height="2"
        rx="1"
        fill={strokeColor(active)}
      />
      <rect
        x="8.5"
        y="14.4736"
        width="7"
        height="2"
        rx="1"
        fill={strokeColor(active)}
      />
    </svg>
  );
};
